export default class ContactInfo {
  constructor() {
    this.maritalStatus = true;
    this.email = true;
    this.phone = true;
    this.address = true;
    this.mailingAddress = true;
  }

  loadData(payload) {
    if (payload.Demographic_Info) {
      this.email = payload.Demographic_Info.Email;
      this.phone = payload.Demographic_Info.Phone_Number;
      this.address = payload.Contact_Address;
      this.mailingAddress = payload.Mailing_Address;
    }

    if (payload.Personal_Info) {
      this.maritalStatus = payload.Personal_Info.Marital_Status;
    }
  }
}
